/* utils.js */

/* sleep */
export function sleep(ms) {
	return new Promise(
		resolve => setTimeout(resolve, ms)
	);
}


/* undef */
export function undef(v) {
	return typeof v === 'undefined';
}
